<template>
  <project-base :state="state">
    <portal
      v-if="competition.requires_collaboration_agreement_upload || project.conditions"
      to="tertiary"
    >
      <ul class="list-reset flex">
        <li class="mr-6">
          <a
            data-turbolinks="false"
            href="#project-contracts"
            class="block text-black no-underline hover:underline py-2"
          >
            Project Contracts
          </a>
        </li>
        <li>
          <a
            data-turbolinks="false"
            href="#additional-requirements"
            class="block text-black no-underline hover:underline py-2"
          >
            Additional Requirements
          </a>
        </li>
      </ul>
    </portal>
    <div class="container mt-6">
      <app-card
        v-if="!hasContracts"
        class="max-w-lg text-center border-collapse mx-auto py-12"
      >
        <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" class="w-32 h-32 mx-auto mb-4">
          <path d="M10 49.985a40 40 0 1 0 80 0 40 40 0 1 0 -80 0Z" fill="#ccf3f9" stroke-width="1"></path>
          <path d="M65.777 75.533a1.107 1.107 0 0 1 -1.214 0.979l-33.95 -3.626a1.106 1.106 0 0 1 -0.979 -1.214l5.045 -47.232 25.18 2.689 9.792 12.134Z" fill="#ffffff" stroke="#021316" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"></path>
          <path d="m45.799 42.46 18.215 1.945" fill="none" stroke="#021316" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"></path>
          <path d="m38.965 46.652 24.529 2.62" fill="none" stroke="#021316" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"></path>
          <path d="m38.445 51.518 24.529 2.62" fill="none" stroke="#021316" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"></path>
          <path d="m37.926 56.384 24.529 2.62" fill="none" stroke="#021316" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"></path>
          <path d="M51.113 63.493a2.224 2.224 0 1 0 3.609 1.967l-0.047 0.443a1.78 1.78 0 0 0 3.539 0.378 1.78 1.78 0 0 0 1.586 1.958l1.327 0.142" fill="none" stroke="#021316" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"></path>
          <path d="m50.055 69.709 10.544 1.126" fill="none" stroke="#5edaed" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"></path>
          <path d="m35.858 68.193 10.544 1.126" fill="none" stroke="#5edaed" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"></path>
          <path d="M37.178 66.476a1.853 1.853 0 1 1 2.006 -1.687" fill="none" stroke="#021316" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"></path>
          <path d="M46.624 64.814a1.853 1.853 0 0 1 -2.007 1.686" fill="none" stroke="#021316" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"></path>
          <path d="M39.131 65.405a1.854 1.854 0 0 1 2.006 -1.687" fill="none" stroke="#021316" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"></path>
          <path d="M42.208 65.671a1.853 1.853 0 0 1 2.007 -1.686" fill="none" stroke="#021316" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"></path>
          <path d="M59.859 27.129 58.805 37a1.105 1.105 0 0 0 0.979 1.213l9.867 1.054Z" fill="#5edaed" stroke="#021316" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"></path>
          <path d="m65.774 75.56 -1.516 -9.347a2.086 2.086 0 0 0 -4.118 0.666l0.643 3.98c0.536 3.316 -3.193 3.122 -2.25 8.956l0.915 5.663 11.345 -1.834a12.394 12.394 0 0 1 -0.2 -4.844c0.546 -3.014 1.041 -5.087 0.494 -8.477 -0.57 -3.525 -1.6 -5.022 -3.84 -8.541Z" fill="#ffffff" stroke-width="1"></path>
          <path d="m72.322 86.566 -0.323 -2a1.1 1.1 0 0 0 -1.264 -0.913l-11.722 1.895a1.1 1.1 0 0 0 -0.913 1.264l0.324 2Z" fill="#ffffff" stroke="#021316" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"></path>
          <path d="m65.774 75.56 -1.516 -9.347a2.086 2.086 0 0 0 -4.118 0.666l0.643 3.98c0.536 3.316 -3.193 3.122 -2.25 8.956l0.915 5.663 11.345 -1.834a12.394 12.394 0 0 1 -0.2 -4.844c0.546 -3.014 1.041 -5.087 0.494 -8.477 -0.57 -3.525 -1.6 -5.022 -3.84 -8.541Z" fill="none" stroke="#021316" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"></path>
          <path d="m58.383 95.1 -0.813 -5.03a1.1 1.1 0 0 1 0.912 -1.264l13.781 -2.227a1.1 1.1 0 0 1 1.265 0.912l0.812 5.03" fill="#5edaed" stroke="#021316" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"></path>
          <path d="m34.679 24.44 1.521 9.347a2.086 2.086 0 1 0 4.118 -0.666l-0.643 -3.98c-0.536 -3.316 3.192 -3.122 2.25 -8.956L41 14.522l-11.341 1.834c0.571 3.387 0.476 3.326 -0.235 7.254a17.972 17.972 0 0 0 1 9.875c0.139 0.575 2.784 4.733 2.784 4.733Z" fill="#ffffff" stroke-width="1"></path>
          <path d="m28.131 13.434 0.323 2a1.1 1.1 0 0 0 1.264 0.913l11.722 -1.9a1.1 1.1 0 0 0 0.913 -1.264l-0.324 -2Z" fill="#ffffff" stroke="#021316" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"></path>
          <path d="m34.679 24.44 1.521 9.347a2.086 2.086 0 1 0 4.118 -0.666l-0.643 -3.98c-0.536 -3.316 3.192 -3.122 2.25 -8.956L41 14.522l-11.341 1.834c0.571 3.387 0.476 3.326 -0.235 7.254a17.972 17.972 0 0 0 1 9.875c0.139 0.575 2.784 4.733 2.784 4.733Z" fill="none" stroke="#021316" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"></path>
          <path d="m42.07 4.9 0.813 5.03a1.1 1.1 0 0 1 -0.913 1.27l-13.78 2.224a1.1 1.1 0 0 1 -1.265 -0.912l-0.813 -5.03" fill="#5edaed" stroke="#021316" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"></path>
        </svg>
        <h2>No Contracts are available to sign</h2>
        <p>We will inform you by email when your contract is available to sign.</p>
      </app-card>
      <section
        v-else
        id="project-contracts"
        class="flex flex-wrap"
      >
        <div
          class="w-full pb-6 xl:mr-12 xl:w-1/4 xl:border-b-2 flex flex-col items-start justify-start"
        >
          <h2 class="leading-tight text-xl">
            Project Contracts
          </h2>
          <p>
            Here you can find all your related contracts for this project. If
            you have any questions, please contact
            <a
              :href="`mailto:${$config.emails.support}`"
            >{{ $config.emails.support }}</a>.
          </p>
        </div>
        <ul class="list-reset -m-6 flex-1 flex flex-wrap">
          <li
            v-for="partner in partners"
            :key="partner.id"
            class="w-full md:w-1/3 p-6 flex"
          >
            <user-contract-card
              :partner="partner"
              class="w-full"
            />
          </li>
        </ul>
      </section>
      <section
        v-if="
          competition.requires_collaboration_agreement_upload ||
            project.conditions
        "
        id="additional-requirements"
        class="flex flex-wrap mt-24"
      >
        <div
          class="w-full pb-6 xl:mr-12 xl:w-1/4 xl:border-b-2 flex flex-col items-start justify-start"
        >
          <h2 class="leading-tight text-xl">
            Additional Requirements
          </h2>
        </div>
        <ul class="list-reset -m-6 flex-1 flex flex-wrap">
          <li
            v-if="competition.requires_collaboration_agreement_upload"
            class="w-full md:w-1/2 p-6 flex"
          >
            <user-collaboration-agreement-card
              :project="project"
              :partners="partners"
            />
          </li>
          <li
            v-if="project.conditions"
            class="w-full md:w-1/2 p-6 flex"
          >
            <user-conditions-card :project="project" />
          </li>
        </ul>
      </section>
    </div>
  </project-base>
</template>

<script>
import { userProjectMixin } from "../../mixins/userProject.js";
export default {
  name: "ProjectViewContractsIndex",
  mixins: [userProjectMixin],
  computed: {
    hasContracts() {
      return this.contract;
    }
  },
  created() {
    document.title = `Project ${this.state.project.ref} Contracts :: ${
      document.title
    }`;
    window._project = this.project.uuid;
    window._user = Object.freeze({
      id: this.state.user.id,
      company_id: this.projectPartner.company_id,
      primary: this.projectPartner.primary,
      isLead: this.isLead,
      isPartner: this.isPartner,
      isViewer: this.isViewer,
      isEditor: this.isEditor
    });
  },
  destroyed() {
    delete window._user;
  }
};
</script>
